export default __webpack_public_path__ + "static/media/Rahul Meena.68918d15.jpg";